import { render, staticRenderFns } from "./WebCameraModal.vue?vue&type=template&id=547020dc&scoped=true"
import script from "./WebCameraModal.vue?vue&type=script&lang=js"
export * from "./WebCameraModal.vue?vue&type=script&lang=js"
import style0 from "./WebCameraModal.vue?vue&type=style&index=0&id=547020dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547020dc",
  null
  
)

export default component.exports